import React from 'react';
import { Box, Button } from '@mui/material';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import * as styles from './styles';

function ToggleWhatsHotOnly({ active, count, onClick }) {
    if (active) {
        return (
            <Box component="button" onClick={onClick} aria-pressed={true} sx={styles.buttonOn}>
                <LocalFireDepartmentIcon sx={styles.flameIconOn} />
                What's Hot! only
                <Box sx={styles.countBadge} aria-label={`${count} publishers`}>
                    {count}
                </Box>
            </Box>
        );
    }

    return (
        <Box sx={{ background: 'linear-gradient(90deg, #00D7FF, #0078FF)', borderRadius: '999px', padding: '1.5px', display: 'inline-flex' }}>
            <Button
                onClick={onClick}
                aria-pressed={false}
                startIcon={<LocalFireDepartmentIcon sx={styles.flameIconOff} />}
                sx={{
                    borderRadius: '999px',
                    px: '1.1rem',
                    py: '0.6rem',
                    border: 'none',
                    background: 'var(--ecal-navy)',
                    color: 'var(--ecal-white)',
                    fontWeight: 600,
                    '&:hover': { background: 'var(--ecal-navy)', border: 'none' },
                }}
            >
                What's Hot! only
            </Button>
        </Box>
    );
}

export default ToggleWhatsHotOnly;
